import { render, staticRenderFns } from "./AllNipInwardsTable.vue?vue&type=template&id=288ec448&scoped=true&"
import script from "./AllNipInwardsTable.vue?vue&type=script&lang=js&"
export * from "./AllNipInwardsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllNipInwardsTable.vue?vue&type=style&index=0&id=288ec448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ec448",
  null
  
)

export default component.exports